import { getInit } from "./InitCarConfig";
import CarConfig from "./components/lexus/CarConfig";

// Webpack entry point for Apheleia Car Configurator Lexus
export const init = getInit(CarConfig);
